"use strict";

import Collapse from 'bootstrap/js/dist/collapse';

export function init() {
    let collapseTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="collapse"]'))
    let collapseList = collapseTriggerList.map(function (collapseTriggerEl) {
        return new Collapse(collapseTriggerEl);
    })
}